import React, {memo, useEffect} from 'react';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import TableTasks from './components/TableTasks';
import FiltersOverlay from './components/FiltersOverlay';

const Tasks = () => {
  const { dispatch, currentUser } = useStoreon<State, Events>('currentUser');
  useEffect(() => {
    /**
     * TODO уточнить насчёт актуальности */
    // if(currentUser.groups){
    //   if (currentUser.user_status === 'superuser'){
    //     dispatch('taskInfo/set', { isMine: false});
    //   }else {
    //     dispatch('taskInfo/set', { groups: currentUser.groups ? getGroupsId(currentUser.groups).join(): null , user: currentUser.id});
    //   }
    // }
    return () => {
      dispatch('tasks/get')
      dispatch('tasks/clear')
    }
  }, [currentUser])

  return (
    <FiltersOverlay>
      {() => {
        return (
            <TableTasks />
        );
      }}
    </FiltersOverlay>
  )
};

export default memo(Tasks);
